import { environment } from '@base/environments/environment';

export function isNewAuthFlowEnabled(): boolean {
  return environment.featureNewAuthFlow === true;
}
